var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_5206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.666 7.67724L10.5 1.01106C10.1667 0.761082 9.83335 0.761082 9.50005 1.01106L0.334014 7.67724C-0.332619 8.09389 0.0840311 9.17713 0.833978 9.17713H2.50054V18.3432C2.50054 18.8431 2.83384 19.1764 3.3338 19.1764H16.6662C17.1661 19.1764 17.4994 18.8431 17.4994 18.3432V9.17713H19.166C19.916 9.17713 20.3326 8.09389 19.666 7.67724ZM10 17.5099C7.25021 17.5099 5.00037 15.2601 5.00037 12.5103C5.00037 9.76045 7.25021 7.51061 10 7.51061C12.7498 7.51061 14.9997 9.76045 14.9997 12.5103C14.9997 15.2601 12.7498 17.5099 10 17.5099Z",
    fill: "#F0FF46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2496 11.2604V8.76053H8.74982V11.2604H6.25V13.7602H8.74982V16.26H11.2496V13.7602H13.7495V11.2604H11.2496Z",
    fill: "#F0FF46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_5206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomee);
export default __webpack_public_path__ + "static/media/homee.c24e36c412cdd4299cd746d54f9a05b5.svg";
export { ForwardRef as ReactComponent };